import { useEffect, useRef, useState } from "react";
import { InView } from "react-intersection-observer";
import { saveAs } from "file-saver";

import download from "assets/img/download.png";

export const CustomVideo = ({ srcVideo, number, length, activeSlide }) => {
  const videoRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    if (videoRef.current !== null) {
      if (length > 1) {
        if (isVisible && number === activeSlide) {
          videoRef.current.play();
        } else {
          videoRef.current.pause();
        }
      } else {
        if (isVisible) {
          videoRef.current.play();
        } else {
          if (videoRef.current.play) {
            videoRef.current.pause();
          }
        }
      }
      /*  */
    }
  }, [isVisible, length, number, activeSlide]);

  return (
    <InView
      onChange={(isVisible) => {
        setIsVisible(isVisible);
      }}
    >
      <div>
        <video width="100%" ref={videoRef} muted controls>
          <source src={srcVideo} type="video/mp4" />
        </video>
      </div>
      <div className="download-container">
        <div className="footer-image not-width">
          <div className="not-width"></div>
          <div className="icon-container not-width">
            <img
              src={download}
              alt={"download"}
              onClick={() => {
                saveAs(`${srcVideo}?original=true`);
              }}
            />
          </div>
          {length > 1 && (
            <div className="not-width">
              <p>{`${number + 1}/${length}`}</p>
            </div>
          )}
        </div>
      </div>
    </InView>
  );
};
